import React from 'react';
import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { CheckmarkCircle24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXXL,
    gap: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3,
  },
});

interface Props {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ icon, title, description, action }: Props) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      {icon || <CheckmarkCircle24Regular fontSize={48} />}
      <Text size={400} weight="semibold">{title}</Text>
      {description && <Text size={300}>{description}</Text>}
      {action}
    </div>
  );
}
